import { SET_PAY_EMBEDDED_DATA } from '../../actions/app/pay/pay.action';

const initState = {
    embedded: null,
};

export const payReducer = (pay = initState, action) => {
    const { payload } = action;

    switch (action.type) {
        case SET_PAY_EMBEDDED_DATA:
            return { ...pay, embedded: payload };

        default:
            return pay;
    }
};
